import { render, staticRenderFns } from "./BindUserList.vue?vue&type=template&id=a8748160&scoped=true&"
import script from "./BindUserList.vue?vue&type=script&lang=js&"
export * from "./BindUserList.vue?vue&type=script&lang=js&"
import style0 from "./BindUserList.vue?vue&type=style&index=0&id=a8748160&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8748160",
  null
  
)

export default component.exports